export default __webpack_public_path__ + "static/media/10.e67f0780.png";